// ArcGIS-native tile service URL for the mosquito-risk layer, so the layer
// can be added to ArcGIS Pro / other GIS tools.
export function mosquitoRiskTileServiceURL(): string {
	return `${window.location.origin}/api/nir/mosquito-risk/MapServer`;
}

// Copy text to the clipboard, falling back to a hidden textarea when the
// Clipboard API is unavailable (non-secure contexts).
export async function copyToClipboard(text: string): Promise<void> {
	try {
		await navigator.clipboard.writeText(text);
	} catch {
		const ta = document.createElement("textarea");
		ta.value = text;
		document.body.appendChild(ta);
		ta.select();
		document.execCommand("copy");
		document.body.removeChild(ta);
	}
}
